import { Pie } from 'react-chartjs-2';
import {
  accountingFormatNumber,
  getLastSevenDays,
  randomDataSetsTDMTotal,
} from '../../../../utils';
import { Chart, ChartTypeRegistry, LegendItem } from 'chart.js';

const PieChart = ({
  labels,
  datasets,
  chartTitle,
  legendPosition,
  legendAlign,
  showValue = false,
  currency = false,
}: {
  labels: string[];
  datasets: { data: any; color: string }[];
  chartTitle: string;
  legendPosition?: any;
  legendAlign?: any;
  showValue?: boolean;
  currency?: boolean;
}) => {
  const lastSevendaysFormatted: string[] = [];
  getLastSevenDays().forEach((date) => {
    lastSevendaysFormatted.push(date.toDateString());
  });

  const totalProject = randomDataSetsTDMTotal(datasets);
  const formattedLabels: string[] = [];
  labels.forEach((labels, i) => {
    formattedLabels.push(
      labels +
        ' (' +
        ((datasets[i].data / totalProject) * 100).toFixed(0) +
        '%)'
    );
  });
  const userData: any = [];
  const dataColors: string[] = [];
  datasets.forEach((d) => {
    userData.push(d.data);
    dataColors.push(d.color);
  });

  return (
    <Pie
      data={{
        labels: labels,
        datasets: [
          {
            label: chartTitle,
            data: userData,
            backgroundColor: dataColors,
          },
        ],
      }}
      options={{
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: legendPosition ? legendPosition : 'left',
            align: legendAlign ? legendAlign : 'end',
            labels: {
              usePointStyle: true,
              pointStyle: 'circle',
              font: { size: 14 },
              padding: 10,
              generateLabels: (
                chart: Chart<
                  keyof ChartTypeRegistry,
                  (number | null)[],
                  unknown
                >
              ): LegendItem[] => {
                const { data } = chart;
                if (data?.labels?.length && showValue) {
                  return data.labels.map((label, i) => ({
                    text: `${label}: ${data?.datasets[0]?.data[i]}${
                      showValue ? '%' : ''
                    }`,
                    fillStyle: dataColors[i],
                    strokeStyle: dataColors[i],
                    lineWidth: 2,
                    datasetIndex: 0,
                  }));
                }
                if (data?.labels?.length && currency) {
                  return data.labels.map((label, i) => ({
                    text: `${label}: ${accountingFormatNumber({
                      num: data?.datasets[0]?.data[i]!,
                      format: 'en-US',
                      currency: 'USD',
                    })}`,
                    fillStyle: dataColors[i],
                    strokeStyle: dataColors[i],
                    lineWidth: 2,
                    datasetIndex: 0,
                  }));
                }
                if (data?.labels?.length) {
                  return data.labels.map((label, i) => ({
                    text: `${label}: ${data?.datasets[0]?.data[i]}`,
                    fillStyle: dataColors[i],
                    strokeStyle: dataColors[i],
                    lineWidth: 2,
                    datasetIndex: 0,
                  }));
                }
                return [];
              },
            },
          },
        },
        scales: {
          xAxis: { display: false },
          yAxis: { display: false },
        },
      }}
    />
  );
};

export default PieChart;
